import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {BONE_DENSITY_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/bone-density-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/bone-density-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/bone-density-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/bone-density-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/bone-density-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const BoneDensityTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case BONE_DENSITY_TEST_KEYS.START:
        trackPageViewGA('/bone-density-test/start', 'MDQ-Bone Density Test - Start');
        return <Questionnaire1Screen />;
      case BONE_DENSITY_TEST_KEYS.PROFILE:
        trackPageViewGA('/bone-density-test/profile', 'MDQ-Bone Density Test - Profile');
        return <Questionnaire2Screen />;
      case BONE_DENSITY_TEST_KEYS.INVALID:
        trackPageViewGA('/bone-density-test/invalid', 'MDQ-Bone Density Test - Invalid');
        return <Questionnaire3Screen />;
      case BONE_DENSITY_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA(
          '/bone-density-test/appointment-preferences',
          'MDQ-Bone Density Test - Appointment Preferences',
        );
        return <Questionnaire4Screen />;
      case BONE_DENSITY_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/bone-density-test/your-test-package', 'MDQ-Bone Density Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default BoneDensityTest;
